import React from 'react';
import { BadgeCheck } from 'lucide-react';

/**
 * Small blue checkmark used next to a token's symbol to indicate it has been
 * verified by the BlokSwap team. Visual is intentionally similar to the
 * Uniswap "verified" badge: filled icon, brand-accent color, sm size.
 *
 * Pass `size` to override the default 14px.
 */
export const VerifiedBadge = ({ size = 14, className = '', title = 'Verified by BlokSwap' }) => (
  <span
    data-testid="verified-badge"
    title={title}
    aria-label={title}
    className={`inline-flex items-center text-amber-400 ${className}`}
  >
    <BadgeCheck size={size} className="fill-amber-400/20" strokeWidth={2.25} />
  </span>
);

export default VerifiedBadge;
